// extracted by mini-css-extract-plugin
export var colorSquare = "_rm-0";
export var danger = "_rm-5";
export var lightPink = "_rm-8";
export var neutralBlue = "_rm-7";
export var neutralYellow = "_rm-6";
export var normal = "_rm-1";
export var primary = "_rm-2";
export var primaryLight = "_rm-3";
export var solidBlack = "_rm-g";
export var solidGreen = "_rm-b";
export var solidLightBlue = "_rm-d";
export var solidNavy = "_rm-c";
export var solidOrange = "_rm-f";
export var solidPink = "_rm-e";
export var solidRed = "_rm-9";
export var solidYellow = "_rm-a";
export var success = "_rm-4";